export const isAuthenticated = () => sessionStorage.getItem("JWT_TOKEN") !== null;
export const getToken = () => sessionStorage.getItem("JWT_TOKEN");
export const login = token => {

    sessionStorage.setItem("JWT_TOKEN",token);
}
export const logout = () => {
    sessionStorage.removeItem("JWT_TOKEN");
}